export default __webpack_public_path__ + "static/media/gmc-mob.f8b30273.svg";